import React, { useEffect, useState } from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import CustomField from "../common/customField";
import {
  onlyNumber,
  onlyNumberdesimal,
  onlyLetters,
} from "../../helpers/formats";
import {
  createEmployee,
  updateEmployee,
} from "../../services/employee.service";
import { toast } from "react-toastify";
import {
  optionsForwageRate,
  optionsForAccountCategory,
  optionsForEmployeeType,
  optionsForPosition,
  optionsForSalaryFrequency,
} from "../common/utlity/options";
import "react-datepicker/dist/react-datepicker.css";
import { intialValuesForEmployee } from "../common/utlity/intialValues";
import CustomPhoneNumberField from "../common/customPhone";
import { TextField } from "@mui/material";
import BeatLoader from "react-spinners/BeatLoader";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { EmployeeSteps } from "../../lib/constants/TourSteps";
import TourGuide from "../common/TourGuide";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { FiUser,FiArrowLeft,FiCreditCard,FiDollarSign} from "react-icons/fi";

const AddEmployee = ({
  close,
  item,
  addEmployeeItem,
  updateEmployeeItem,
  businessUuid,
}) => {
  const [selectedSection, setSelectedSection] = useState("Employee_Details");
  const [employeeIsLoading, setEmployeeIsLoading] = useState(false);

  const employees = useSelector((state) => state?.employees?.employees);
  const { t } = useTranslation();
  const [showeyePassword, setShoweyePassword] = useState(false);
  // const [password, setPassword] = useState(item?.password || "");
  const [runTour, setRunTour] = useState(false);
  const { bussinessUuid: paramUuid } = useParams();
  const finalBusinessUuid = businessUuid || paramUuid;
  const navigate = useNavigate();

  const validationSchemaforEmployee = Yup.object().shape({
    employeeName: Yup.string()
      .required(
        <span className="text-xs dark:text-red-500">Name is required</span>
      )
      .matches(/^[a-zA-Z\s]+$/, "Name must contain only letters")
      .min(2, "Name must be at least 2 characters")
      .max(50, "Name must be at most 50 characters"),

    phoneNumber: Yup.string()
      .required(
        <span className="text-xs dark:text-red-500">Mobile is required</span>
      )
      .min(10, "Number must be at least 10 digits")
      .max(15, "Number must be at most 10 digits"),
    pincode: Yup.string().test(
      "is-valid-pincode",
      "Pincode must be between 5 and 10 digits",
      (value) => !value || /^[0-9]{5,10}$/.test(value)
    ),
    accountNumber: Yup.string().matches(/^[0-9]+$/, "Only numbers are allowed"),
    wageAmount: Yup.string().when("employeeType", {
      is: "part_time",
      then: () => Yup.string().required("Wage Amount is required"),
    }),
    employeeSalary: Yup.string().when("employeeType", {
      is: "full_time",
      then: () => Yup.string().required("Salary Amount is required"),
    }),
  });
  const togglePasswordVisibility = () => {
    setShoweyePassword((prev) => !prev);
  };
  const onSubmit = async (values, { resetForm }) => {
    if (!finalBusinessUuid) {
      toast.error("Business UUID is missing");
      return;
    }

    const dataForSave = {
      ...values,
      password: values.password || "", // Ensure password is included
      bussinessUuid: finalBusinessUuid,
    };

    try {
      setEmployeeIsLoading(true);

      if (item) {
        const { employeeID } = item;
        const result = await updateEmployee(
          finalBusinessUuid,
          employeeID,
          dataForSave
        );

        if (result.status === 200) {
          if (typeof updateEmployeeItem === "function") {
            updateEmployeeItem(result?.data, true);
          }
          toast.success(t("Updated Successfully"));
          close(true);
          navigate(-1)
        } else {
          throw new Error(t("Something Went  wrong!"));
        }
      } else {
        const result = await createEmployee(finalBusinessUuid, dataForSave);

        if (result.status === 201) {
          if (typeof addEmployeeItem === "function") {
            addEmployeeItem(result?.data, true);
          }
          toast.success(t("Added Successfully"));
          resetForm();
          close();
          navigate(-1)
        } else if (result?.response?.status === 400) {
          throw new Error(result.response.data.message);
        } else {
          throw new Error(result?.data?.message || t("Something Went  wrong!"));
        }
      }
    } catch (error) {
      toast.error(error.message);
      console.error("Error:", error);
    } finally {
      setEmployeeIsLoading(false); // Set loading to false when done
    }
  };
  useEffect(() => {
    const waitForElements = () => {
      const allElementsExist = document.querySelector(
        ".employee-role-tour" && ".employee-type-tour"
      );
      //  document.querySelector(".transaction-status-tour");

      if (employees?.length === 0 && allElementsExist) {
        setRunTour(true);
      } else {
        setTimeout(waitForElements, 300);
      }
    };

    waitForElements();
  }, [employees]);
  const handleChangeperhour = (setFieldValue, e, values) => {
    const { name, value } = e.target;

    setFieldValue(name, value);
    if (
      (name === "wageRate" || name === "wageAmount" || name === "totalHours") &&
      values.payFrequency === "weekly"
    ) {
      const wageValue = parseFloat(values.wageRate || values.wageAmount || 0);
      const weeklyWorkingHours = 5 * 7;
      const perHourValue = wageValue / weeklyWorkingHours;

      setFieldValue("perHour", perHourValue.toFixed(2));
    }
  };

  return (
    <>
      <TourGuide steps={EmployeeSteps} runTour={runTour} />
      <Formik
        // enableReinitialize={true}
        initialValues={intialValuesForEmployee(item ? item : null)}
        validationSchema={validationSchemaforEmployee}
        onSubmit={onSubmit}
      >
        {(formik) => {
          const {
            errors,
            values,
            touched,
            handleChange,
            setFieldValue,
            handleBlur,
          } = formik;
          return (
            <Form>
              <div className="bg-white h-screen dark:bg-slate-900 border border-slate-200/80 dark:border-slate-700 shadow-lg shadow-slate-200/40 dark:shadow-black/20 p-4 transition-all duration-300">
              <button
                type="button"
                onClick={() => navigate(-1)}
                className="flex items-center justify-center w-11 h-11 mb-3 rounded-xl border border-gray-300 dark:border-gray-700 bg-white dark:bg-slate-800 hover:bg-blue-50 dark:hover:bg-slate-700 transition-all shadow-sm"
              >
                <FiArrowLeft className="text-xl text-gray-700 dark:text-white" />
              </button>
                    <div className="mt-1 pl-4 pr-4 pt-3 rounded-xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gradient-to-br dark:from-slate-900 dark:via-indigo-950 dark:to-slate-800 shadow-[0_0_15px_rgba(0,0,0,0.08)] dark:shadow-[0_0_20px_rgba(0,0,0,0.4)]">
                       <div className="flex items-center gap-3 mb-3">
                                                          <div className=" rounded-full flex items-center justify-center">
                                                            <FiUser
                                          size={20}
                                          className="text-blue-600 dark:text-white"
                                        />
                                                          </div>
                                        
                                                          <h2 className="text-1xl font-semibold text-slate-800 dark:text-white">
                                                            {t('TABLE.EMPLOYEE_DETAILS')}
                                                          </h2>
                                                        </div>
                <div className="mt-4">
                      <div className="grid grid-cols-1 mt-2 sm:grid-cols-2 lg:grid-cols-4 gap-4">
                        {/* Employee Name */}
                        <div className="p-2 mt-1 col-span-1">
                          <CustomField
                            type="text"
                            name="employeeName"
                            label={t("FORM.EMPLOYEE_NAMEE")}
                            placeholder="Employee Name"
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            value={values.employeeName}
                            error={errors.employeeName}
                            onKeyPress={onlyLetters}
                            touched={touched.employeeName}
                            className="w-full"
                          />
                        </div>

                        {/* Mobile Number */}
                        <div className="p-2 mt-1 col-span-1">
                          <CustomPhoneNumberField
                            name="phoneNumber"
                            country={values.countryCode}
                            label={t("FORM.PHONE")}
                            placeholder="Mobile number"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.phoneNumber}
                            error={errors.phoneNumber}
                            touched={touched.phoneNumber}
                            className="w-full"
                          />
                        </div>
                        <div className="p-2 mt-1 employee-role-tour">
                          {values.position !== "other" ? (
                            <CustomField
                              type="select"
                              name="position"
                              label={t("FORM.SELECT_ROLE")}
                              placeholder="Select Role"
                              options={optionsForPosition}
                              setFieldValue={(name, value) => {
                                setFieldValue(name, value);
                              }}
                              handleChange={(e) => {
                                handleChange(e);
                                if (e.target.value !== "other") {
                                  setFieldValue("otherPosition", "");
                                }
                              }}
                              value={values.position}
                              error={errors.position}
                              touched={touched.position}
                            />
                          ) : (
                            <div className=" ">
                              <TextField
                                type="text"
                                name="otherPosition"
                                label={t("FORM.ENTER_ROLE")}
                                placeholder="Enter Role"
                                onChange={handleChange}
                                value={values.otherPosition}
                                error={
                                  values.position === "other" &&
                                  values.otherPosition === ""
                                    ? true
                                    : false
                                }
                                helperText={
                                  values.position === "other" &&
                                  values.otherPosition === ""
                                    ? "Other Role Is Required"
                                    : "Enter your own Role"
                                }
                                size="small"
                                sx={{
                                  "& .MuiOutlinedInput-root": {
                                    height: "30px",
                                  },
                                  "& .MuiInputBase-input": {
                                    padding: "2px 6px",
                                  },
                                }}
                                InputProps={{
                                  className:
                                    "dark:text-white dark:bg-[#1f2937] dark:border-white focus:border-blue-600",
                                }}
                                InputLabelProps={{
                                  className: "dark:text-white",
                                  sx: {
                                    transform: "translate(14px, 9px) scale(1)",
                                    "&.Mui-focused": {
                                      transform:
                                        "translate(14px, -9px) scale(0.75)",
                                    },
                                    "&.MuiFormLabel-filled": {
                                      transform:
                                        "translate(14px, -9px) scale(0.75)",
                                    },
                                  },
                                }}
                                FormHelperTextProps={{
                                  sx: {
                                    marginLeft: 0,
                                  },
                                  className: "dark:text-white",
                                }}
                              />
                            </div>
                          )}
                        </div>
                        {/* Employee Type */}
                        <div className="p-2 mt-1 col-span-1 employee-type-tour">
                          <CustomField
                            type="select"
                            name="employeeType"
                            label={t("FORM.EMPLOYEE_TYPE")}
                            placeholder="Employee Type"
                            handleChange={handleChange}
                            options={optionsForEmployeeType}
                            value={values.employeeType}
                            setFieldValue={setFieldValue}
                            helperText={
                              item ? (
                                <span className="text-gray-600 dark:text-red-500">
                                  Changing Employee Type will delete previous
                                  data
                                </span>
                              ) : (
                                ""
                              )
                            }
                            className="w-full "
                          />
                        </div>
                      </div>

                      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
                        <div className="p-2">
                          <CustomField
                            type="date"
                            name="employmentStartDate"
                            label={t("FORM.JOINING_DATE")}
                            placeholder="Employment Start Date"
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            value={values.employmentStartDate}
                            error={errors.employmentStartDate}
                            touched={touched.employmentStartDate}
                          />
                        </div>
                        <div className="p-2">
                          <CustomField
                            type="text"
                            name="address"
                            label={t("FORM.ADDRESS")}
                            placeholder="Address"
                            handleChange={handleChange}
                            value={values.address}
                            helperText={
                              <span className="text-gray-600 dark:text-white">
                                Use Space only
                              </span>
                            }
                          />
                        </div>
                        <div className="p-2">
                          <CustomField
                            type="text"
                            name="pincode"
                            label={t("SIDER.PINCODE")}
                            placeholder="pincode"
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            value={values.pincode}
                            error={errors.pincode}
                            touched={touched.pincode}
                            onKeyPress={onlyNumber}
                            maxLength={10}
                          />
                        </div>
                        <div className="p-2">
                          <CustomField
                            type="text"
                            name="aadharCardNumber"
                            label={t("FORM.ADHARCARD_NUMBER")}
                            placeholder="Aadhar Number"
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            onKeyPress={onlyNumber}
                            value={values.aadharCardNumber}
                            error={errors.aadharCardNumber}
                            touched={touched.aadharCardNumber}
                          />
                        </div>
                      </div>
                      <div className="grid grid-cols-1 mt-2 sm:grid-cols-2 lg:grid-cols-4 gap-4">
                        {values.employeeType === "part_time" && (
                          <>
                            <div className="col-span-1 p-1">
                              <CustomField
                                type="select"
                                name="wageRate"
                                placeholder="Wage Rate"
                                label={t("FORM.WAGE_RATE")}
                                options={optionsForwageRate}
                                handleChange={(e) => {
                                  handleChange(e);
                                  handleChangeperhour(setFieldValue, e, values);
                                }}
                                value={values.wageRate}
                              />
                            </div>
                            <div className="col-span-1 p-1 relative flex">
                              <CustomField
                                type="text"
                                name="wageAmount"
                                label={t("FORM.WAGE_AMOUNT")}
                                placeholder="Wage Amount"
                                value={values.wageAmount}
                                handleChange={(e) => {
                                  handleChange(e);
                                  handleChangeperhour(setFieldValue, e, values);
                                }}
                                handleBlur={handleBlur}
                                onKeyPress={onlyNumberdesimal}
                                className="w-full border-2 p-1 rounded-lg pr-10"
                                error={errors.wageAmount && touched.wageAmount}
                              />

                              <div className="absolute mt-1 right-0 flex items-center pr-3">
                                <select
                                  className="text-gray-700 dark:bg-[#020617] dark:text-white border-l border-gray-400 dark:border-gray-600 focus:outline-none appearance-none"
                                  name="currency"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  value={values.currency}
                                  style={{ minWidth: "2rem" }}
                                >
                                  <option
                                    value="INR"
                                    className="dark:bg-[#020617] dark:text-white"
                                    style={{
                                      fontWeight: "bold",
                                      textAlign: "center",
                                    }}
                                  >
                                  INR
                                  </option>
                                  <option
                                    value="USD"
                                    className="dark:bg-[#020617] dark:text-white"
                                    style={{
                                      fontWeight: "bold",
                                      textAlign: "center",
                                    }}
                                  >
                                  USD
                                  </option>
                                  <option
                                    value="EUR"
                                    className="dark:bg-[#020617] dark:text-white"
                                    style={{
                                      fontWeight: "bold",
                                      textAlign: "center",
                                    }}
                                  >
                                  EUR
                                  </option>
                                  <option
                                    value="GBP"
                                    className="dark:bg-[#020617] dark:text-white"
                                    style={{
                                      fontWeight: "bold",
                                      textAlign: "center",
                                    }}
                                  >
                                  GBP
                                  </option>
                                  <option
                                    value="JPY"
                                    className="dark:bg-[#020617] dark:text-white"
                                    style={{
                                      fontWeight: "bold",
                                      textAlign: "center",
                                    }}
                                  >
                                  JPY
                                  </option>
                                </select>
                              </div>
                            </div>
                            <div className="col-span-1 p-1">
                              <CustomField
                                type="text"
                                name="totalHours"
                                label={t("WAGEPAYROLL.TOTAL_HOURS")}
                                placeholder="Total Hours"
                                value={values.totalHours}
                                handleChange={(e) => {
                                  handleChange(e);
                                  handleChangeperhour(setFieldValue, e, values);
                                }}
                                handleBlur={handleBlur}
                                onKeyPress={onlyNumberdesimal}
                                className="w-full border-2 p-1 rounded-lg pr-10"
                                error={errors.totalHours && touched.totalHours}
                                required
                              />
                            </div>
                            <div className="mb-4 p-1">
                              <CustomField
                                type="select"
                                name="payFrequency"
                                label={t("FORM.PAY_FREQUENCY")}
                                placeholder="Pay Frequency"
                                value={values.payFrequency}
                                options={optionsForwageRate}
                                handleChange={handleChange}
                              />
                            </div>
                          </>
                        )}
                      </div>
                      <div className="grid grid-cols-1 mt-2 sm:grid-cols-2 lg:grid-cols-4 gap-4">
                        {values.employeeType === "full_time" && (
                          <>
                            <div className="p-2">
                              <CustomField
                                type="select"
                                name="salaryFrequency"
                                placeholder="Frequency"
                                label={t("FORM.SALARY_FREQUENCY")}
                                options={optionsForSalaryFrequency}
                                handleChange={handleChange}
                                value={values.salaryFrequency}
                                error={errors.salaryFrequency}
                                touched={touched.salaryFrequency}
                                setFieldValue={setFieldValue}
                              />
                            </div>
                            <div className="p-2 relative">
                              <div className="relative flex">
                                <CustomField
                                  type="text"
                                  name="employeeSalary"
                                  label={t("FORM.SALARY")}
                                  placeholder="Employee Salary"
                                  handleChange={handleChange}
                                  handleBlur={handleBlur}
                                  value={values.employeeSalary}
                                  error={errors.employeeSalary}
                                  touched={touched.employeeSalary}
                                  onKeyPress={onlyNumberdesimal}
                                  className="w-full border-2 p-1 rounded-lg pr-10"
                                />
                                <div className="absolute mt-1 right-0 flex items-center pr-10">
                                  <select
                                    className="text-gray-700 dark:bg-gray-800 dark:text-white border-l border-gray-400 dark:border-gray-600 focus:outline-none appearance-none"
                                    name="currency"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.currency}
                                    style={{ minWidth: "2rem" }}
                                  >
                                    <option
                                      value="INR"
                                      className="bg-white text-black dark:bg-[#020617] dark:text-white"
                                      style={{
                                        fontWeight: "semibold",
                                        textAlign: "center",
                                      }}
                                    >
                                      ₹ INR
                                    </option>
                                    <option
                                      value="USD"
                                      className="bg-white text-black dark:bg-[#020617] dark:text-white"
                                      style={{
                                        fontWeight: "semibold",
                                        textAlign: "center",
                                      }}
                                    >
                                      💵 USD
                                    </option>
                                    <option
                                      value="EUR"
                                      className="bg-white text-black dark:bg-[#020617] dark:text-white"
                                      style={{
                                        fontWeight: "semibold",
                                        textAlign: "center",
                                      }}
                                    >
                                      💶 EUR
                                    </option>
                                    <option
                                      value="GBP"
                                      className="bg-white text-black dark:bg-[#020617] dark:text-white"
                                      style={{
                                        fontWeight: "semibold",
                                        textAlign: "center",
                                      }}
                                    >
                                      💷 GBP
                                    </option>
                                    <option
                                      value="JPY"
                                      className="bg-white text-black dark:bg-[#020617] dark:text-white"
                                      style={{
                                        fontWeight: "semibold",
                                        textAlign: "center",
                                      }}
                                    >
                                      💴 JPY
                                    </option>
                                  </select>
                                </div>
                              </div>
                            </div>
                            <div className="p-2">
                              <CustomField
                                type="time"
                                name="startTime"
                                label={t("FORM.SIFT_TIME_START")}
                                placeholder="Shift Start Time"
                                handleChange={handleChange}
                                timeIntervals={5}
                                value={values.startTime}
                                setFieldValue={setFieldValue}
                                error={errors.startTime}
                                touched={touched.startTime}
                              />
                            </div>
                            <div className="p-2">
                              <CustomField
                                type="time"
                                name="endTime"
                                label={t("FORM.SIFT_TIME_END")}
                                placeholder="Shift End Time"
                                handleChange={handleChange}
                                timeIntervals={5}
                                value={values.endTime}
                                setFieldValue={setFieldValue}
                              />
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                </div>
                    <div className="mt-1 p-4 rounded-xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gradient-to-br dark:from-slate-900 dark:via-indigo-950 dark:to-slate-800 shadow-[0_0_15px_rgba(0,0,0,0.08)] dark:shadow-[0_0_20px_rgba(0,0,0,0.4)]">
                      
<div className="flex items-center gap-3 mb-3">
                                                          <div className=" rounded-full flex items-center justify-center">
                                                            <FiCreditCard
                                          size={20}
                                          className="text-blue-600 dark:text-white"
                                        />
                                                          </div>
                                        
                                                          <h2 className="text-1xl font-semibold text-slate-800 dark:text-white">
                                                            {t('FORM.ACCOUNT_AND_CREDIT')}
                                                          </h2>
                                                        </div>
                      <div className="mt-4">
                        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 mt-2">
                          <div className="bg-white dark:bg-[#020617]">
                            {/* <div className='p-2'> */}
                            {/* <CommonLabel
                            htmlFor='accountNumber'
                            labelText='Account Number'
                          /> */}
                            <CustomField
                              type="text"
                              id="accountNumber"
                              name="accountNumber"
                              label={t("SIDER.ACCOUNT_NUMBER")}
                              placeholder="Account Number"
                              handleChange={handleChange}
                              handleBlur={handleBlur}
                              value={values.accountNumber}
                              error={errors.accountNumber}
                              touched={touched.accountNumber}
                              onKeyPress={onlyNumber}
                            />
                            {/* </div> */}
                          </div>
                          <div className="bg-white dark:bg-[#020617]">
                            {/* <div className='p-2'> */}
                            {/* <CommonLabel
                            htmlFor='ifscCode'
                            labelText='IFSC Code'
                          /> */}
                            <CustomField
                              type="text"
                              name="ifscCode"
                              label={t("SIDER.IFSC_CODE")}
                              placeholder="IFSC Code"
                              handleChange={handleChange}
                              handleBlur={handleBlur}
                              value={values.ifscCode}
                              error={errors.ifscCode}
                              touched={touched.ifscCode}
                              maxLength={11}
                            />
                            {/* </div> */}
                          </div>
                          <div className="bg-white dark:bg-[#020617]">
                            {/* <div className='p-1 mt-1'> */}
                            {/* <CommonLabel
                            htmlFor='accountType'
                            labelText='Account Type'
                          /> */}

                            <CustomField
                              type="select"
                              name="accountType"
                              placeholder="Account Type"
                              label={t("FORM.ACCOUNT_TYPE")}
                              options={optionsForAccountCategory}
                              handleChange={handleChange}
                              value={values.accountType}
                              setFieldValue={setFieldValue}
                            />
                            {/* </div> */}
                          </div>
                          <div className="bg-white dark:bg-[#020617]">
                              <CustomField
                                type="date"
                                name="employeepaidDate"
                                label={t("FORM.PAID_DATE")}
                                placeholder="Paid Date"
                                handleChange={handleChange}
                                handleBlur={handleBlur}
                                value={values.employeepaidDate}
                                error={errors.employeepaidDate}
                                touched={touched.employeepaidDate}
                              />
                            </div>
                            <div className="relative dark:bg-[#020617]">
                              <CustomField
                                type={showeyePassword ? "text" : "password"}
                                name="password"
                                label={t("FORM.PASSWORD")}
                                className="w-full "
                                placeholder="Password"
                                value={values.password || ""}
                                handleChange={handleChange}
                                required
                                size="small"
                              />
                              <span
                                className="absolute right-3 top-1.5 cursor-pointer text-gray-500"
                                onClick={togglePasswordVisibility}
                              >
                                {showeyePassword ? (
                                  <FaEyeSlash className="h-5 w-5" />
                                ) : (
                                  <FaEye className="h-5 w-5" />
                                )}
                              </span>
                            </div>
                        </div>
                        <div className="grid grid-cols-1 mt-2 sm:grid-cols-2 lg:grid-cols-4 gap-4">
                            {/* <div className='bg-white dark:bg-[#020617]'>
                              <CustomField
                                type='text'
                                name='advanceSalaryPaid'
                                label={t("FORM.ADVANCE_AMOUNT_PAID")}
                                placeholder='Advance Amount Paid'
                                handleChange={handleChange}
                                handleBlur={handleBlur}
                                onKeyPress={onlyNumber}
                                value={values.advanceSalaryPaid}
                                error={errors.advanceSalaryPaid}
                                touched={touched.advanceSalaryPaid}
                              />
                            </div> */}
                            
                            
                        </div>
                      </div>
                    </div>

                    <div className="mt-1 pl-4 pr-4 pt-3 rounded-xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gradient-to-br dark:from-slate-900 dark:via-indigo-950 dark:to-slate-800 shadow-[0_0_15px_rgba(0,0,0,0.08)] dark:shadow-[0_0_20px_rgba(0,0,0,0.4)]">             

 <div className="flex items-center gap-3 mb-3">
                                    <div className=" rounded-full flex items-center justify-center">
                                      <FiDollarSign
                    size={20}
                    className="text-blue-600 dark:text-white"
                  />
                                    </div>
                  
                                    <h2 className="text-1xl font-semibold text-slate-800 dark:text-white">
                                     {t('REPORT.PAYROLL_SETTING')}
                                    </h2>
                                  </div>

                      <div className="grid grid-cols-3 ">
                        <div className="p-2 mt-1">
                          <CustomField
                            type="text"
                            name="seakLeave"
                            label={t("FORM.SICK_LEAVE")}
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            value={values.seakLeave}
                            error={errors.seakLeave}
                            onKeyPress={onlyNumber}
                            touched={touched.seakLeave}
                          />
                        </div>
                        <div className="p-2 mt-1">
                          <CustomField
                            type="text"
                            name="paidLeave"
                            label={t("FORM.PAID_LEAVE")}
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            value={values.paidLeave}
                            error={errors.paidLeave}
                            onKeyPress={onlyNumber}
                            touched={touched.paidLeave}
                          />
                        </div>

                        <div className="p-2 mt-1">
                          <CustomField
                            type="text"
                            name="deductions"
                            label={t("FORM.DEDUCTION")}
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            value={values.deductions}
                            error={errors.deductions}
                            onKeyPress={onlyNumber}
                            touched={touched.deductions}
                            helperText={
                              <span className="text-gray-600 dark:text-red-500">
                                Pf and other
                              </span>
                            }
                          />
                        </div>
                      </div>
                    </div>

                <div className="flex justify-end mt-4">
                  {item ? (
                    <button
                      type="submit"
                      className="w-1/2 py-2 px-2 bg-blue-600 hover:bg-blue-700 text-white  mt-4 font-bold rounded justify-content-right"
                      disabled={employeeIsLoading}
                    >
                      <span>{t("FORM.UPDATE_EMPLOYEE")}</span>
                      {employeeIsLoading && (
                        <span className="ml-2">
                          <BeatLoader
                            color="#5556d3"
                            loading={employeeIsLoading}
                            size={8}
                          />
                        </span>
                      )}
                    </button>
                  ) : (
                    <button
                      type="submit"
                      className="w-1/2 py-2 px-2 bg-blue-600 hover:bg-blue-700 text-white mt-4 font-bold rounded justify-content-right"
                      disabled={employeeIsLoading}
                    >
                      {employeeIsLoading ? (
                        <BeatLoader
                          size={8}
                          color="#ffffff"
                          loading={employeeIsLoading}
                        />
                      ) : (
                        t("FORM.ADD_EMPLOYEE")
                      )}
                    </button>
                  )}
                </div>
              </div>
            </Form>
          );
        }}
      </Formik>
    </>
  );
};

export default AddEmployee;
